/**
 * "Productos relacionados" carousel (PDP): forces exactly one card per
 * arrow click, instead of the shared <slideshow-component>'s default
 * behaviour of stepping by however many slides are currently visible
 * (assets/slideshow.js `nextIndex`/`previousIndex`, used unmodified by
 * every other carousel in the theme).
 *
 * Intercepted with a capture-phase listener scoped to
 * .volts-related-products only, calling the component's own public
 * select()/current API directly — no other carousel, and no shared
 * component file, is touched.
 */

document.addEventListener(
  'click',
  (event) => {
    const button = /** @type {Element} */ (event.target).closest(
      '.volts-related-products .slideshow-control:not([disabled])'
    );
    if (!button) return;

    // Never touch a product card's own internal media-gallery arrows.
    if (button.closest('.product-card') || button.closest('.resource-list__item')) return;

    const component = button.closest('slideshow-component');
    if (!component || typeof component.select !== 'function') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const delta = button.classList.contains('slideshow-control--next') ? 1 : -1;
    component.select(component.current + delta, event);
  },
  true
);
